import { memo, useEffect } from 'react'
import { rocketGameLiveService } from '../../../services/rockets-games-lives'
import { useGlobalStore } from '../../../store/global-store'
import { Timer } from './components/timer'
import { useLiveRocketGame } from './use-live-rocket-game'

export const RocketGame = memo(() => {
  const { currentRocketGameLive } = useLiveRocketGame()
  const liveId = useGlobalStore((state) => state.liveId)

  const bombId = currentRocketGameLive?.id
  const dateFinal = currentRocketGameLive?.dateFinalInExploded

  // Dispara o close NO EXATO MOMENTO em que a janela da bomba termina.
  // setTimeout baseado no dateFinal exato (robusto — não depende do countdown
  // visual chegar em 0:0). O server é idempotente; o jitter espalha entre os
  // espectadores; o cleanup cancela ao trocar de bomba (swap) ou desmontar.
  useEffect(() => {
    if (!bombId || !dateFinal) return

    const remaining = new Date(dateFinal).getTime() - Date.now()
    const delay = Math.max(0, remaining) + Math.floor(Math.random() * 1500)

    const t = setTimeout(() => {
      rocketGameLiveService
        .closeNow({ rocketGameLiveId: bombId, liveId: liveId ?? undefined })
        .catch(() => {})
    }, delay)

    return () => clearTimeout(t)
  }, [bombId, liveId, dateFinal])

  return (
    <div
      className="flex items-center justify-center w-screen
    h-screen"
    >
      {currentRocketGameLive?.dateFinalInExploded && (
        <Timer
          key={currentRocketGameLive?.dateFinalInExploded}
          currentRocketGameLive={currentRocketGameLive}
        />
      )}
    </div>
  )
})
